import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import type { SensitivityIconSlots, SensitivityIconState } from './SensitivityIcon.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const sensitivityIconClassNames: SlotClassNames<SensitivityIconSlots> = {
  root: 'fai-SensitivityIcon',
  foregroundIcon: 'fai-SensitivityIcon__foregroundIcon',
  backgroundIcon: 'fai-SensitivityIcon__backgroundIcon',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {},
  backgroundIcon: {
    position: 'absolute',
    zIndex: 0,
  },

  foregroundIcon: {
    position: 'relative',
    zIndex: 1,
    color: tokens.colorNeutralForeground1,
  },
});

/**
 * Apply styling to the SensitivityIcon slots based on the state
 */
export const useSensitivityIconStyles_unstable = (state: SensitivityIconState): SensitivityIconState => {
  const styles = useStyles();
  state.root.className = mergeClasses(sensitivityIconClassNames.root, styles.root, state.root.className);

  if (state.foregroundIcon) {
    state.foregroundIcon.className = mergeClasses(
      sensitivityIconClassNames.foregroundIcon,
      styles.foregroundIcon,
      state.foregroundIcon.className,
    );
  }

  if (state.backgroundIcon) {
    state.backgroundIcon.className = mergeClasses(
      sensitivityIconClassNames.backgroundIcon,
      styles.backgroundIcon,
      state.backgroundIcon.className,
    );
  }

  return state;
};
